<template>
    <div class="inline-flex items-center justify-center text-center align-middle m-0 p-0">
        <!-- MODO VISUALIZACIÓN -->
        <div
            v-if="!isEditing"
            @click="startEdit"
            class="group/inline cursor-pointer py-0.5 px-1 rounded hover:bg-slate-100 inline-flex items-center justify-center gap-1 transition text-slate-800"
            :title="'Clic para editar ' + label"
        >
            <span :class="valueClass">
                <slot>{{ formattedDisplayValue }}</slot>
            </span>
            <i class="fa-solid fa-pen text-[9px] text-slate-400 opacity-0 group-hover/inline:opacity-100 transition-opacity"></i>
        </div>

        <!-- MODO EDICIÓN -->
        <div v-else class="inline-flex items-center justify-center text-center align-middle m-0 p-0">
            <template v-if="type === 'select'">
                <select
                    ref="inputRef"
                    v-model="editValue"
                    @blur="saveEdit"
                    @keydown.enter.prevent="saveEdit"
                    @keydown.esc.prevent="cancelEdit"
                    class="text-xs py-0.5 px-1 border border-primary rounded bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary text-center leading-tight"
                    style="width: auto !important; max-width: 100% !important;"
                >
                    <option v-for="opt in options" :key="opt.value" :value="opt.value">
                        {{ opt.label }}
                    </option>
                </select>
            </template>
            <template v-else>
                <input
                    ref="inputRef"
                    type="text"
                    inputmode="decimal"
                    v-model="editValue"
                    :style="compactInputStyle"
                    @blur="saveEdit"
                    @keydown.enter.prevent="saveEdit"
                    @keydown.esc.prevent="cancelEdit"
                    class="text-xs py-0.5 px-1 border border-primary rounded bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-primary text-center font-medium leading-tight inline-block"
                />
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "InlineEditableCell",
    props: {
        value: {
            required: true
        },
        field: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: "text" // text, number, select
        },
        label: {
            type: String,
            default: ""
        },
        options: {
            type: Array,
            default: () => []
        },
        valueClass: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            isEditing: false,
            editValue: this.value,
            isSaving: false
        };
    },
    watch: {
        value(newVal) {
            this.editValue = newVal;
        }
    },
    computed: {
        formattedDisplayValue() {
            if (this.type === 'select') {
                const found = this.options.find(o => o.value == this.value);
                return found ? found.label : this.value;
            }
            return this.value;
        },
        compactInputStyle() {
            const str = this.editValue !== null && this.editValue !== undefined ? String(this.editValue) : "";
            const length = Math.max(str.length, 1);
            return {
                width: `calc(${length}ch + 10px) !important`,
                maxWidth: '100% !important',
                minWidth: '24px !important',
                boxSizing: 'content-box !important',
                fieldSizing: 'content'
            };
        }
    },
    methods: {
        startEdit() {
            this.editValue = this.value;
            this.isEditing = true;
            this.$nextTick(() => {
                if (this.$refs.inputRef) {
                    this.$refs.inputRef.focus();
                    if (this.type !== 'select' && this.$refs.inputRef.select) {
                        this.$refs.inputRef.select();
                    }
                }
            });
        },
        cancelEdit() {
            this.isEditing = false;
            this.editValue = this.value;
        },
        saveEdit() {
            if (!this.isEditing) return;
            if (this.editValue == this.value) {
                this.isEditing = false;
                return;
            }

            this.isSaving = true;
            this.$emit('update-value', {
                field: this.field,
                value: this.editValue,
                done: (success) => {
                    this.isSaving = false;
                    if (success) {
                        this.isEditing = false;
                    }
                }
            });
        }
    }
};
</script>
